import React, { useCallback } from 'react';
import { View } from 'react-native';
import { rem } from 'design-system/values';
import { IconEdit, IconPaperDownload } from 'design-system/icons';
import IconClose from 'design-system/icons/IconClose';
import NavigationHeaderRightIconButton from 'design-system/NavigationHeaderRightIconButton';
import { showExportDataMethodModal } from 'features/export-data/ExportDataMethodModal';
import { selectHasLiveExportFeature } from 'features/export-data-live/selectors';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const TransactionsHeader = ({ isEditing, onPressEdit, onExport, showExport, filters, from, to, }) => {
    const pressEdit = () => {
        onPressEdit?.(!isEditing);
    };
    const colors = useColors();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const hasLiveExportFeature = useAppSelector(selectHasLiveExportFeature);
    const onPressExport = useCallback(() => {
        if (onExport) {
            onExport();
            return;
        }
        const accountIds = Object.keys(filters?.selectedAccountsObj || {}).map((id) => Number(id));
        const exportDataParams = { accountIds, from, to };
        if (hasLiveExportFeature) {
            showExportDataMethodModal({ exportDataParams });
        }
        else {
            navigation.navigateDeprecated('ExportData', exportDataParams);
        }
    }, [filters?.selectedAccountsObj, from, hasLiveExportFeature, onExport, to]);
    return (<View style={styles.headerRightContainer}>
      {!!showExport && (<NavigationHeaderRightIconButton onPress={onPressExport} style={styles.noMarginRight}>
          <IconPaperDownload color={colors.elements.primary}/>
        </NavigationHeaderRightIconButton>)}
      <NavigationHeaderRightIconButton onPress={pressEdit}>
        {isEditing ? (<IconClose alt color={colors.elements.primary}/>) : (<IconEdit color={colors.elements.primary}/>)}
      </NavigationHeaderRightIconButton>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    headerRightContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: rem(8),
    },
    closeIcon: {
        width: rem(16),
        height: rem(16),
    },
    noMarginRight: {
        marginRight: 0,
    },
}));
export default TransactionsHeader;
